<template>
  <div class="crud_form_wrapper store_payment_details">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.announcement_payment_details") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #f7941e">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Loading -->
    <div v-if="loading" class="text-center py-5">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <!-- End:: Loading -->

    <div v-else class="single_step_form_content_wrapper">
      <!-- Start:: Transaction Data Section (بيانات العملية) -->
      <div class="details_section mb-4">
        <h5 class="section_title">
          <i class="fal fa-credit-card"></i>
          {{ $t("TITLES.transaction_data") }}
        </h5>
        <div class="row">
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="info_card">
              <span class="label">{{ $t("PLACEHOLDERS.transaction_id") }}</span>
              <span class="value">{{
                announcementData.transaction_id || "-"
              }}</span>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="info_card">
              <span class="label">{{
                $t("PLACEHOLDERS.transaction_date")
              }}</span>
              <span class="value">{{
                formatDateTime(announcementData.payed_at)
              }}</span>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="info_card">
              <span class="label">{{ $t("PLACEHOLDERS.amount_paid") }}</span>
              <span class="value"
                >{{ announcementData.package_price }}
                {{ $t("PLACEHOLDERS.sar") }}</span
              >
            </div>
          </div>
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="info_card">
              <span class="label">{{ $t("PLACEHOLDERS.payment_status") }}</span>
              <v-chip
                :color="getPaymentStatusColor(announcementData.payemnt_status)"
                text-color="white"
                small
              >
                {{ getPaymentStatusText(announcementData.payemnt_status) }}
              </v-chip>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="info_card">
              <span class="label">{{
                $t("PLACEHOLDERS.payment_gateway_code")
              }}</span>
              <span class="value">{{
                announcementData.payemnt_method || "-"
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- End:: Transaction Data Section -->

      <!-- Start:: Announcement Data Section (بيانات الإعلان المرتبط) -->
      <div class="details_section mb-4">
        <h5 class="section_title">
          <i class="fal fa-bullhorn"></i>
          {{ $t("TITLES.announcement_data") }}
        </h5>
        <div class="row">
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="info_card">
              <span class="label">{{
                $t("PLACEHOLDERS.announcement_name")
              }}</span>
              <span class="value">{{ announcementData.name || "-" }}</span>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="info_card">
              <span class="label">{{
                $t("PLACEHOLDERS.announcement_creation_date")
              }}</span>
              <span class="value">{{
                formatDateTime(announcementData.created_at)
              }}</span>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="info_card">
              <span class="label">{{
                $t("PLACEHOLDERS.publication_date")
              }}</span>
              <span class="value">{{
                formatDateTime(announcementData.updated_at)
              }}</span>
            </div>
          </div>
          <div
            class="col-md-12 col-sm-12 mb-3"
            v-if="announcementData.dates && announcementData.dates.length > 0"
          >
            <div class="info_card">
              <span class="label">{{
                $t("PLACEHOLDERS.announcement_schedule")
              }}</span>
              <div class="dates_list">
                <div
                  v-for="(dateItem, index) in announcementData.dates"
                  :key="index"
                  class="date_item"
                >
                  <v-chip small color="primary" outlined class="ma-1">
                    {{ formatDateTime(dateItem.start_at) }} -
                    {{ formatDateTime(dateItem.end_at) }}
                  </v-chip>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="info_card">
              <span class="label">{{ $t("PLACEHOLDERS.city") }}</span>
              <span class="value">{{ announcementData.city_name || "-" }}</span>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="info_card">
              <span class="label">{{
                $t("PLACEHOLDERS.required_attendance")
              }}</span>
              <span class="value">{{
                announcementData.guests_number || 0
              }}</span>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="info_card">
              <span class="label">{{
                $t("PLACEHOLDERS.confirmed_attendance")
              }}</span>
              <span class="value">{{
                announcementData.confirmed_users || 0
              }}</span>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="info_card">
              <span class="label">{{
                $t("PLACEHOLDERS.announcement_status")
              }}</span>
              <v-chip
                :color="getStatusColor(announcementData.status)"
                text-color="white"
                small
              >
                {{ getStatusText(announcementData.status) }}
              </v-chip>
            </div>
          </div>
        </div>
      </div>
      <!-- End:: Announcement Data Section -->

      <!-- Start:: Provider Data Section (بيانات مقدم الخدمة) -->
      <div class="details_section mb-4">
        <h5 class="section_title">
          <i class="fal fa-store"></i>
          {{ $t("TITLES.provider_data") }}
        </h5>
        <div class="row">
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="info_card">
              <span class="label">{{ $t("PLACEHOLDERS.store_name") }}</span>
              <span class="value">{{
                announcementData.store_brand_name || "-"
              }}</span>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="info_card">
              <span class="label">{{ $t("PLACEHOLDERS.phone") }}</span>
              <span class="value">{{
                announcementData.store_mobile || "-"
              }}</span>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="info_card">
              <span class="label">{{ $t("PLACEHOLDERS.email") }}</span>
              <span class="value">{{
                announcementData.store_email || "-"
              }}</span>
            </div>
          </div>
          <div class="col-md-4 col-sm-6 mb-3">
            <div class="info_card">
              <span class="label">{{
                $t("PLACEHOLDERS.commercial_register")
              }}</span>
              <span class="value">{{
                announcementData.commercial_register || "-"
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- End:: Provider Data Section -->

      <!-- Start:: Images Section -->
      <div
        class="details_section"
        v-if="announcementData.images && announcementData.images.length > 0"
      >
        <h5 class="section_title">
          <i class="fal fa-images"></i>
          {{ $t("TITLES.images") }}
        </h5>
        <div class="row">
          <div
            class="col-md-3 col-sm-4 mb-3"
            v-for="(image, index) in announcementData.images"
            :key="index"
          >
            <img
              :src="image"
              class="announcement-image"
              @click="openImageModal(image)"
            />
          </div>
        </div>
      </div>
      <!-- End:: Images Section -->
    </div>

    <!-- Start:: Image Modal -->
    <v-dialog v-model="imageModal" max-width="800px">
      <v-card>
        <v-card-text class="text-center">
          <img :src="selectedImage" style="width: 100%; height: auto" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="imageModal = false">
            {{ $t("BUTTONS.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End:: Image Modal -->
  </div>
</template>

<script>
export default {
  name: "ShowStorePayment",

  data() {
    return {
      loading: false,
      imageModal: false,
      selectedImage: null,

      announcementData: {
        id: null,
        name: null,
        store_id: null,
        store_brand_name: null,
        store_mobile: null,
        store_email: null,
        commercial_register: null,
        city_name: null,
        status: null,
        created_at: null,
        updated_at: null,
        dates: [],
        transaction_id: null,
        payemnt_status: null,
        payemnt_method: null,
        payed_at: null,
        package_price: null,
        guests_number: null,
        confirmed_users: null,
        images: [],
      },
    };
  },

  methods: {
    // Start:: Format Date Time
    formatDateTime(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      const locale = this.$i18n.locale === "ar" ? "ar-SA" : "en-US";

      const formattedDate = date.toLocaleDateString(locale, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });

      const formattedTime = date.toLocaleTimeString(locale, {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      return `${formattedDate} ${formattedTime}`;
    },
    // End:: Format Date Time

    // Start:: Get Status Color
    getStatusColor(status) {
      switch (status) {
        case "published":
          return "success";
        case "expired":
          return "error";
        case "pending":
          return "warning";
        default:
          return "grey";
      }
    },
    // End:: Get Status Color

    // Start:: Get Status Text
    getStatusText(status) {
      switch (status) {
        case "published":
          return this.$t("PLACEHOLDERS.published");
        case "expired":
          return this.$t("PLACEHOLDERS.expired");
        case "pending":
          return this.$t("PLACEHOLDERS.pending");
        default:
          return "-";
      }
    },
    // End:: Get Status Text

    // Start:: Get Payment Status Color
    getPaymentStatusColor(status) {
      switch (status) {
        case "successed":
          return "success";
        case "not_payed":
        case "failed":
          return "error";
        default:
          return "warning";
      }
    },
    // End:: Get Payment Status Color

    // Start:: Get Payment Status Text
    getPaymentStatusText(status) {
      switch (status) {
        case "successed":
          return this.$t("PLACEHOLDERS.payment_success");
        case "not_payed":
          return this.$t("PLACEHOLDERS.payment_pending");
        case "failed":
          return this.$t("PLACEHOLDERS.payment_failed");
        default:
          return "-";
      }
    },
    // End:: Get Payment Status Text

    // Start:: Open Image Modal
    openImageModal(image) {
      this.selectedImage = image;
      this.imageModal = true;
    },
    // End:: Open Image Modal

    // Start:: Get Announcement Data
    async getAnnouncementData() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: `announcements/show/store-payments/${this.$route.params.id}`,
        });

        const data = res.data.data.Announcement;

        this.announcementData = {
          id: data.id,
          name: data.name,
          store_id: data.store_id,
          store_brand_name: data.store_brand_name,
          store_mobile: data.store_mobile,
          store_email: data.store?.email || null,
          commercial_register: data.store?.commercial_register || null,
          city_name: data.city?.name_ar || data.city?.name || null,
          status: data.status,
          created_at: data.created_at,
          updated_at: data.updated_at,
          dates: data.dates || [],
          transaction_id: data.transaction_id,
          payemnt_status: data.payemnt_status,
          payemnt_method: data.payemnt_method,
          payed_at: data.payed_at,
          package_price: data.package_price,
          guests_number: data.guests_number,
          confirmed_users: data.confirmed_users,
          images: data.images || [],
        };

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error.response?.data?.message);
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.errorOccurred")
        );
      }
    },
    // End:: Get Announcement Data
  },

  created() {
    this.getAnnouncementData();
  },
};
</script>

<style lang="scss" scoped>
.store_payment_details {
  .details_section {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

    .section_title {
      color: #f7941e;
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 20px;
      padding-bottom: 10px;
      border-bottom: 2px solid #f7941e;

      i {
        margin-inline-end: 8px;
      }
    }

    .info_card {
      background: #f8f9fa;
      border-radius: 6px;
      padding: 15px;
      height: 100%;

      .label {
        display: block;
        font-size: 13px;
        color: #6c757d;
        margin-bottom: 5px;
      }

      .value {
        display: block;
        font-size: 15px;
        font-weight: 600;
        color: #333;
      }
    }
  }

  .announcement-image {
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }
  }
}
</style>
